const vaporAsset = function asset(path) {
    return window.Vapor.asset(path);
};
export { vaporAsset };
